export default "__VITE_ASSET__66038099__"